import { Injectable } from '@angular/core';
import { Route, UrlSegment, UrlTree, CanActivate, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';

import { Observable } from 'rxjs';
import { AuthService } from '../service/auth.service';

@Injectable({
  providedIn: 'root'
})
export class RoleGuard implements CanActivate {
  constructor(private authService: AuthService) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    let roles = route?.data?.['roles'] as Array<string>;
    if (roles && roles.length) {
      return this.authService.hasOneOfRoles(roles);
    }
    // si on n'a défini aucune restriction de rôle, au autorise l'activation
    return true;
  }
}
